import { render, staticRenderFns } from "./WarrantyBook.vue?vue&type=template&id=36e2f25c&scoped=true&"
import script from "./WarrantyBook.vue?vue&type=script&lang=js&"
export * from "./WarrantyBook.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyBook.vue?vue&type=style&index=0&id=36e2f25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2f25c",
  null
  
)

export default component.exports